import type { RentalView } from './types';

/**
 * Owner 2026-11-01: the tag of a closed event's rental — red „Anulowano – wydarzenie odwołane / usunięte” (the row is
 * struck through, it counts in nothing), or the warning „Wydarzenie odwołane – sprawdź rozliczenie z dostawcą” (picked
 * up or returned before: it counts).
 */
export function RentalMarkTag({ mark }: { mark: RentalView['mark'] }) {
  if (!mark) return null;
  return <span className={`small rental-note rental-mark rental-mark-${mark.kind}`}>{mark.label}</span>;
}
